export { GroupAnimation } from './animation/GroupAnimation.mjs';
export { GroupAnimationWithThen } from './animation/GroupAnimationWithThen.mjs';
export { NativeAnimation } from './animation/NativeAnimation.mjs';
export { getValueTransition } from './animation/utils/get-value-transition.mjs';
export { calcGeneratorDuration, maxGeneratorDuration } from './animation/generators/utils/calc-duration.mjs';
export { createGeneratorEasing } from './animation/generators/utils/create-generator-easing.mjs';
export { isGenerator } from './animation/generators/utils/is-generator.mjs';
export { cubicBezierAsString } from './animation/waapi/easing/cubic-bezier.mjs';
export { isWaapiSupportedEasing } from './animation/waapi/easing/is-supported.mjs';
export { mapEasingToNativeEasing } from './animation/waapi/easing/map-easing.mjs';
export { supportedWaapiEasing } from './animation/waapi/easing/supported.mjs';
export { startWaapiAnimation } from './animation/waapi/start-waapi-animation.mjs';
export { attachTimeline } from './animation/waapi/utils/attach-timeline.mjs';
export { generateLinearEasing } from './animation/waapi/utils/linear.mjs';
export { cancelFrame, frame, frameData, frameSteps } from './frameloop/frame.mjs';
export { createRenderBatcher } from './frameloop/batcher.mjs';
export { cancelMicrotask, microtask } from './frameloop/microtask.mjs';
export { time } from './frameloop/sync-time.mjs';
export { isDragActive, isDragging } from './gestures/drag/state/is-active.mjs';
export { setDragLock } from './gestures/drag/state/set-active.mjs';
export { hover } from './gestures/hover.mjs';
export { press } from './gestures/press/index.mjs';
export { isNodeOrChild } from './gestures/utils/is-node-or-child.mjs';
export { isPrimaryPointer } from './gestures/utils/is-primary-pointer.mjs';
export { recordStats } from './stats/index.mjs';
export { activeAnimations } from './stats/animation-count.mjs';
export { statsBuffer } from './stats/buffer.mjs';
export { isBezierDefinition } from './utils/is-bezier-definition.mjs';
export { resolveElements } from './utils/resolve-elements.mjs';
export { supportsFlags } from './utils/supports/flags.mjs';
export { supportsLinearEasing } from './utils/supports/linear-easing.mjs';
export { supportsScrollTimeline } from './utils/supports/scroll-timeline.mjs';
export { MotionValue, collectMotionValues, motionValue } from './value/index.mjs';
export { ViewTransitionBuilder, animateView } from './view/index.mjs';
